// Open an email thread's reader in place, from anywhere a work row is shown
// (Patrick, 2026-10-20: "opening an email thread should not redirect to the
// client overview page; the modal should just open in place").
//
// The row carries the thread's work item id; the thread itself is read from
// the Email lane's own endpoint so the reader shows exactly what the lane
// would. One hook, two callers: the row title (WorkItemLink) and the Read
// verb (WorkActions).
import React, { Suspense, useState } from 'react';
import { Snackbar } from '@mui/material';
import { fetchEmailThreads } from '../CS/ClientOverview/api';

const EmailThreadDialog = React.lazy(() => import('../CS/ClientOverview/EmailThreadDialog'));

const stop = (e) => { if (e && e.stopPropagation) e.stopPropagation(); if (e && e.preventDefault) e.preventDefault(); };

export function useEmailReader(item, onChanged) {
    const [state, setState] = useState({ loading: false, thread: null, error: '' });
    const open = async (e) => {
        stop(e);
        if (state.loading) return;
        setState({ loading: true, thread: null, error: '' });
        try {
            const d = await fetchEmailThreads(item.clientId);
            const t = (d?.threads || []).find((x) => x.workItemId === item.id || x.rowId === item.email?.rowId);
            if (!t) throw new Error('This thread is not in the Email lane any more (the sweep may have re-keyed it); open it in Outlook.');
            setState({ loading: false, thread: t, error: '' });
        } catch (err) {
            setState({ loading: false, thread: null, error: (err && err.message) || String(err) });
        }
    };
    // The dialog is a portal, but React events still bubble to the row: the wrapper stops them.
    const host = (state.thread || state.error) ? (
        <span onClick={stop} role="presentation">
            {state.thread && (
                <Suspense fallback={null}>
                    <EmailThreadDialog
                        thread={state.thread} clientId={item.clientId} clientTitle={item.clientTitle || ''}
                        onClose={() => setState({ loading: false, thread: null, error: '' })}
                        onChanged={() => { onChanged && onChanged(); }} />
                </Suspense>
            )}
            <Snackbar open={!!state.error} autoHideDuration={6000} onClose={() => setState((x) => ({ ...x, error: '' }))}
                message={state.error} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
        </span>
    ) : null;
    return { open, loading: state.loading, host };
}
